var url = "89d222e9b4ea3c0a56c2155b25139e36.svg";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;